import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { formatPercentage } from 'common/formatters';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import SrButton, {
  SR_BUTTON_HEIGHT_MEDIUM,
  SR_BUTTON_THEME_ADOBE_BLUE_INVERTED,
  SR_BUTTON_FONT_SIZE_SMALL,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrListingTermsOfService.less';

const SrListingTermsOfService = (
  {
    formikBag,
    formFields,
    partner,
  }
) => {
  const [showTermsOfServiceModal, setShowTermsOfServiceModal] = useState(false);

  return (
    <>
      <SrCard padding='20px 20px 22px 20px'>
        <SrButton
          heightType={SR_BUTTON_HEIGHT_MEDIUM}
          iconUrl='/images/terms-of-service-icon.svg'
          theme={SR_BUTTON_THEME_ADOBE_BLUE_INVERTED}
          fontSizeType={SR_BUTTON_FONT_SIZE_SMALL}
          onClick={() => setShowTermsOfServiceModal(true)}
        >
          View Referral Agreement
        </SrButton>
        {formFields.map((formField) => (
          <SrBox
            key={formField.id}
          >
            <SrFormikField
              formField={formField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
          </SrBox>
        ))}
      </SrCard>
      {showTermsOfServiceModal && (
        <SrModalV2
          theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
          buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
          onClose={() => setShowTermsOfServiceModal(false)}
          contentPadding='34px 26px 260px'
        >
          <SrBox styleName='termsOfServiceContainer'>
            <SrText
              font='greycliff'
              color='blueGreycliff'
              size='30'
              lineHeight='36px'
              display='block'
              weight='800'
            >
              Referral Agreement
            </SrText>
            <SrBox marginTop='22px'>
              <SrText
                display='block'
                weight='700'
              >
                Listing Services
              </SrText>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
              >
                PARTIES:
              </SrText>
              &nbsp;
              <SrText>
                The parties to this agreement (this listing) are:&nbsp;
              </SrText>
              <SrText display='block'>
                Agent: {partner.displayName}
              </SrText>
              <SrText display='block'>
                Broker: B&Z Homes, Inc. d/b/a Sunroom Rentals
              </SrText>
              <SrText display='block'>
                Director of Sales: Cody Frank
              </SrText>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
              >
                Appointment.
              </SrText>
              &nbsp;
              <SrText>
                Subject to the terms and conditions of this Agreement, agent
                hereby appoints Sunroom as agent’s exclusive provider of lease listing services,
                for properties submitted through the Sunroom portal, and Sunroom hereby accepts
                such appointment.
              </SrText>
            </SrBox>
            <SrBox marginTop='10px'>
              <SrText>
                Sunroom’s sole authority under such appointment shall be to list, market, and
                promote lease listings and solicit Tenants (defined below) for vacancies in the Area
                (the “
                <SrText weight='700'>
                  Lease Listing Services
                </SrText>
                ”).
              </SrText>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
              >
                Term.
              </SrText>
              &nbsp;
              <SrText>
                This Agreement shall be effective as of the Effective Date and shall remain
                in force until terminated pursuant to this Section 4. Either Sunroom or agent may
                unilaterally terminate this Agreement for any or no reason upon thirty (30) days’
                written notice to the other Parties.
              </SrText>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
              >
                Renter Qualifications.
              </SrText>
              &nbsp;
              <SrText>
                Sunroom agrees to only lease to renters that meet the
                qualifications set by “agent”.
              </SrText>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
              >
                Compensation.
              </SrText>
              &nbsp;
              <SrText>
                For each lease listing, Sunroom shall be entitled to earn a
                commission.&nbsp;
                <SrText weight='700'>
                  {
                    'Agent will pay Sunroom the ' +
                    `${formatPercentage(partner.commissionPercentage)} ` +
                    'of 1st months rent'
                  }
                </SrText>
                &nbsp;within 30 days of the date the corresponding lease begins.
              </SrText>
            </SrBox>
            <SrBox
              margin='32px 0'
              width='100%'
              height='1px'
              backgroundColor='#132630'
            />
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
                display='block'
              >
                1. Appointment as Exclusive Lease Listing Services Provider.
              </SrText>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  a. In the interests of clarity, the Parties agree that (i) Sunroom’s exclusive
                  appointment shall include the right for Sunroom to receive the Commission
                  (defined above) and all application fees; (ii) except as expressly set forth herein,
                  agent retains all other assets and obligations, including its rights, duties and
                  obligations under each Customer Contract with respect to Management Services; and
                  (iii) agent shall not provide Lease Listing Services itself.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  b.
                  <SrText weight='800'>
                    &nbsp;WHEREAS
                  </SrText>
                  , agent provides Lease Listing Services (defined above) to its customers
                  and, in the course of its business, has developed and continues to develop valuable
                  contractual relationships with such customers (“Customer Contracts”);
                  <SrText weight='800'>
                    &nbsp;WHEREAS
                  </SrText>
                  ,
                  Sunroom is in the business of providing Lease Listing Services; and,
                  <SrText weight='800'>
                    &nbsp;WHEREAS
                  </SrText>
                  ,
                  agent desires to appoint Sunroom as its exclusive provider of Lease Listing Services,
                  and Sunroom desires to accept such appointment.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText>
                  c.&nbsp;
                  <SrText
                    weight='800'
                    decoration='underline'
                  >
                    Area.
                  </SrText>
                  &nbsp;As used herein,
                  <SrText weight='800'>
                    &nbsp;"Area"&nbsp;
                  </SrText>
                  means cities where Sunroom operates, including
                  but not limited to Austin-Round Rock Metropolitan, Houston, Dallas, and San Antonio.
                  In the event that Sunroom expands its operations to include
                  additional areas, the Parties shall meet and have good faith
                  negotiations with respect to the potential expansion of the Area definition.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText>
                  d.&nbsp;
                  <SrText
                    weight='800'
                    decoration='underline'
                  >
                    Tenants.
                  </SrText>
                  &nbsp;As used herein,
                  <SrText weight='800'>
                    &nbsp;"Tenants"&nbsp;
                  </SrText>
                  means only those existing or prospective tenants meeting
                  the lawful tenant criteria set forth by agent and communicated to Sunroom.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText>
                  e.&nbsp;
                  <SrText
                    weight='800'
                    decoration='underline'
                  >
                    Leases.
                  </SrText>
                  &nbsp;Pursuant to this Agreement, Sunroom shall only offer leases approved by agent.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText>
                  e.&nbsp;
                  <SrText
                    weight='800'
                    decoration='underline'
                  >
                    Sunroom Restrictions.
                  </SrText>
                  &nbsp; Sunroom agrees that for the period of time during which Sunroom provides Lease
                  Listing Services under this Agreement, Sunroom will not, either directly or indirectly,
                  provide Management Services and/or Sales Services to any Person within the area in
                  which the agent generally provides such services. As used herein,
                  <SrText weight='800'>
                    &nbsp;“Person”&nbsp;
                  </SrText>
                  means any individual, firm,
                  partnership, corporation or other entity, including any successor (by merger or
                  otherwise) of such entity, or a group of any of the foregoing acting in concert. In the
                  interests of clarity, the Parties agree that the prohibition contained in this Section 3
                  shall not prevent Sunroom from (i) marketing Management Services and/or Sales Services
                  for any Person, (ii) receiving any referral payment from any Person with respect to
                  Management Services and/or Sales Services provided by such Person; or (iii) providing
                  Management Services and/or Sales Services to Sunroom’s employees or such employees’
                  family members.
                </SrText>
              </SrBox>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
                display='block'
              >
                2. Term and Termination.
              </SrText>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  a. If either Sunroom, or agent defaults in the performance of any material provision
                  of this Agreement, then the nondefaulting Party may give written notice to the
                  defaulting Party that if the default is not cured within thirty (30) days
                  from the date of such notice, the non-defaulting party may terminate this Agreement.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  b. Notwithstanding anything to the contrary in this Agreement, upon thirty (30) days’
                  written notice to Sunroom, agent may terminate Sunroom’s exclusivity and/or this
                  Agreement with respect to Sunroom’s provision of Lease Listing Services for any
                  specific properties.
                </SrText>
              </SrBox>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
                display='block'
              >
                3. Warranties; Disclaimer
              </SrText>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  a.&nbsp;
                  <SrText decoration='underline'>
                    Mutual Representations and Warranties.
                  </SrText>&nbsp;agent and Sunroom each represents and warrants to the other that: (i) it has
                  the necessary power and authority to enter into this Agreement; (ii) the execution and
                  performance of this Agreement have been authorized by all necessary corporate or
                  institutional actions (excluding approval for any equity grant); (iii) the performance of
                  such obligations and duties does not conflict with and will not result in a breach of any
                  other agreement of such Party or any judgment, order, or decree by which such Party is
                  bound; (iv) it possesses all governmental licenses and approvals necessary to perform its
                  obligations under this Agreement; and (v) in performing its obligations under this
                  Agreement, it will comply in all material respects with all applicable laws and regulations,
                  including any laws or regulations concerning labor practices, anti-corruption, environmental
                  protection or privacy.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  b.&nbsp;
                  <SrText decoration='underline'>
                    Disclaimer.
                  </SrText>
                  &nbsp;TO THE MAXIMUM EXTENT PERMITTED BY LAW, EACH PARTY EXPRESSLY DISCLAIMS ALL WARRANTIES
                  AND REPRESENTATIONS (EXCEPT AS SET FORTH IN THIS SECTION 5), EXPRESS OR IMPLIED.&nbsp;
                  <SrText
                    decoration='underline'
                    weight='800'
                  >
                    Limitation of Liability.
                  </SrText>
                  &nbsp;EXCEPT TO THE EXTENT OF A PARTY’S INFRINGEMENT OR MISAPPROPRIATION OF THE OTHER
                  PARTY’S INTELLECTUAL PROPERTY RIGHTS, OR WILLFUL MISCONDUCT, IN NO EVENT WILL ANY PARTY
                  BE LIABLE TO ANOTHER PARTY FOR ANY SPECIAL, INCIDENTAL, PUNITIVE, INDIRECT, EXEMPLARY,
                  OR CONSEQUENTIAL DAMAGES, OR FOR LOST REVENUE, LOST PROFITS, COST OF REPLACEMENT OF
                  GOODS OR SERVICES, LOSS OF TECHNOLOGY, GOODWILL, RIGHTS OR SERVICES, OR LOSS OF DATA.
                </SrText>
              </SrBox>
            </SrBox>
            <SrBox marginTop='22px'>
              <SrText
                weight='700'
                decoration='underline'
                display='block'
              >
                4. Miscellaneous
              </SrText>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  a.&nbsp;
                  <SrText decoration='underline'>
                    Independent Contractors.
                  </SrText>&nbsp;The relationship between agent and Sunroom established by this
                  Agreement is solely that of independent contractors. Neither Party is in any
                  way the partner or agent of the other, nor is either Party authorized or empowered
                  to create or assume any obligation of any kind, implied or expressed, on behalf of the other
                  Party, without the express prior written consent of such other Party.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  b.&nbsp;
                  <SrText decoration='underline'>
                    Notices.
                  </SrText>&nbsp;All notices, requests, consents, claims, demands, waivers,
                  summons and other legal process, and other similar types of communications
                  hereunder (each, a&nbsp;
                  <SrText weight='800'>
                    “Notice”
                  </SrText>
                  ) must be in writing and addressed to the relevant Party
                  at the address set forth below (or to such other address that may be designated
                  by the receiving Party from time to time in accordance with this Section 7(c)).
                  All Notices must be delivered by personal delivery, nationally recognized
                  overnight courier (with all fees pre-paid, return receipt requested), certified
                  or registered mail (return receipt requested, postage prepaid), or email (read
                  receipt or receipt confirmation required).
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  c.&nbsp;
                  <SrText decoration='underline'>
                    Choice of Law and Venue.
                  </SrText>&nbsp;This Agreement shall be governed by and construed and enforced in
                  accordance with the laws of the United States of America and the State of Texas,
                  without giving effect to any law that would result in the application of a different
                  body of law. The Parties agree that any action, proceeding, controversy or claim between
                  them arising out of or relating to this Agreement shall be brought only in a court of
                  competent jurisdiction in Travis County, Texas, and each Party hereby submits to the
                  personal jurisdiction and venue of such courts and waives any objection on the grounds
                  of venue, forum non-conveniens or any similar grounds.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  d.&nbsp;
                  <SrText decoration='underline'>
                    Amendment and Waiver.
                  </SrText>&nbsp;This Agreement, and each of the terms and provisions hereof, may only
                  be amended, modified, waived, or supplemented by an agreement in writing signed by
                  each Party or the Party against which any such waiver is to be enforced.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  e.&nbsp;
                  <SrText decoration='underline'>
                    Counterparts.
                  </SrText>&nbsp;This Agreement may be executed in counterparts, each of which is deemed
                  an original, but all of which together constitutes one and the same agreement.
                  Delivery of an executed counterpart of this Agreement electronically or by facsimile
                  shall be effective as delivery of an original executed counterpart of this Agreement.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText
                  display='block'
                >
                  f.&nbsp;
                  <SrText decoration='underline'>
                    Interpretation.
                  </SrText>&nbsp;If any term or provision of this Agreement is invalid, illegal or
                  unenforceable in any jurisdiction, such invalidity, illegality, or unenforceability
                  shall not affect any other term or provision of this Agreement or invalidate or
                  render unenforceable such term or provision in any other jurisdiction. For the purposes
                  of this Agreement: (i) the words “such as,” “include,” “includes” and “including” shall
                  be deemed to be followed by the words “without limitation;” (ii) the word “or” is not
                  exclusive; and (iii) the words “herein,” “hereof,” “hereby,” “hereto” and “hereunder”
                  refer to this Agreement as a whole. This Agreement shall be construed without regard
                  to any presumption or rule requiring construction or interpretation against the party
                  drafting an instrument or causing any instrument to be drafted.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  g.&nbsp;
                  <SrText decoration='underline'>
                    Entire Agreement.
                  </SrText>&nbsp;This Agreement constitutes the sole and entire agreement of the Parties
                  with respect to the subject matter contained herein, and supersedes all prior and
                  contemporaneous understandings, agreements, representations, and warranties, both
                  written and oral, with respect to such subject matter.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  h.&nbsp;
                  <SrText
                    decoration='underline'
                  >
                    No Third-Party Beneficiaries.
                  </SrText>&nbsp;The Parties do not confer any rights or remedies upon any person
                  other than the Parties and their respective successors and permitted assign.
                </SrText>
              </SrBox>
              <SrBox margin='15px 0 0 15px'>
                <SrText display='block'>
                  i. Commissions and Application Fees shall be stated in U.S. dollars and shall be subject to
                  all applicable governmental statutes, regulations and rulings, including the withholding of
                  any taxes required by law.
                </SrText>
              </SrBox>
            </SrBox>
          </SrBox>
        </SrModalV2>
      )}
    </>
  );
};

SrListingTermsOfService.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrListingTermsOfService.displayName = 'SrListingTermsOfService';

export default SrListingTermsOfService;
